// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetCasePharmacyResponseModel {
    static getAttributeTypeMap() {
        return GetCasePharmacyResponseModel.attributeTypeMap;
    }
}
GetCasePharmacyResponseModel.discriminator = undefined;
GetCasePharmacyResponseModel.additionalProperties = false;
GetCasePharmacyResponseModel.attributeTypeMap = [
    {
        "name": "pharmacyData",
        "baseName": "pharmacyData",
        "type": "PharmacyModel"
    },
    {
        "name": "pointOfContactData",
        "baseName": "pointOfContactData",
        "type": ""
    },
];
//# sourceMappingURL=getCasePharmacyResponseModel.js.map